import { ReactElement } from 'react';

import styles from './RecentMedicaidId.module.scss';

interface IRecentMedicaidIdProps {
  medicaidId: string;
}

const RecentMedicaidId = ({ medicaidId }: IRecentMedicaidIdProps): ReactElement => (
  <span className={styles.recentMedicaidId}>
    <span className={styles.fixed}>(Medicaid ID: </span>
    <span className={styles.id}>{medicaidId}</span>
    <span className={styles.fixed}>)</span>
  </span>
);

export default RecentMedicaidId;
